'use strict';

//=include  ../dataLayer.js
import DataLayer from '../dataLayer'

export default class ListTrackerData {


    constructor(paxes, hotelParam, rateParam) {
        this._paxes = paxes;
        this._hotelParam = hotelParam;
        this._rateParam = rateParam;

        this.analytics = window.__pt.fn.analytics;
        this.events = window.__pt.fn.analytics.events;
        this.place = window.__pt.place || {};
        this.booker = window.__pt.box || {};
        this.settings = window.__pt.settings || {};
        this.pages = window.__pt.fn.analytics.pages;
        this.fn = window.__pt.fn || {}
        this.waitingList = [];
        this.onRenderCardImageFn();
        window.__pt.renderLazyload = this.onRenderCardImage;

        this.initialize();
        this.setCurrentSearch();
        this.setViewSearchResult();
    }

    initialize() {
        this.date = this.fn.getDate();
        this.url = `${location.origin}${location.pathname}`;
        this.url_full = `${location.href}`;
        this.checkIn = this.fn.getDate(this.booker.checkIn);
        this.checkOut = this.fn.getDate(this.booker.checkOut);
        this.days = this.fn.diffBetweenDays(this.checkIn, this.checkOut);
        [this.CheckInYear, this.CheckInMon, this.CheckInDay] = this.booker.checkIn.split("-");
        [this.CheckOutYear, this.CheckOutMon, this.CheckOutDay] = this.booker.checkOut.split("-");
    }

    setCurrentSearch() {
        const data = {
            event: this.events.gtmEvent,
            eventName: this.events.gtmEvent,
            eventAction: 'list',
            eventCategory: this.events.hotels,
            eventLabel: `${this.place.displayText} | ${this.place.code} | p${this.place.id}`,
            eventExtra: ''
        }

        this.analytics.set(this.events.gtmEvent, data);
    }


    setViewSearchResult() {
        const data = {
            event: this.events.trackEvent,
            eventName: this.events.viewSearchResults,
            eventCategory: this.events.hotels,
            eventAction: 'list',
            eventLabel: `${this.place.displayText.toLowerCase()}`,
            eventExtra: ''
        }

        this.analytics.set(this.events.gtmEvent, data);
    }

    ad(id, paxes, query) {

        const data = {
            event: `ad-skyscraper-${id}`
        };

        data[`adSkyscraper${id}`] = {
            adDivId: `ad-skyscraper-${id}`,
            destination: this.place.displayText,
            hotelId: "",
            hotelStars: "",
            paymentType: "",
            placeid: this.place.id,
            step: this.events.list,
            product: "ro",
            productCountry: "",
            adults: paxes.adults,
            kids: paxes.children,
            rooms: this.booker.pax.length,
            nights: this.days,
            checkinDay: this.CheckInDay,
            checkinMonth: this.CheckInMon,
            checkinYear: this.CheckInYear,
            checkoutDay: this.CheckOutDay,
            checkoutMonth: this.CheckOutMon,
            checkoutYear: this.CheckOutYear,
            campaignToken: query.CampaignToken,
            profileId: query.profileId
        };

        this.analytics.set(this.events.ads, data);
    }

    selectedFilter(category, filter) {
        const data = {
            event: this.events.trackEvent,
            eventName: this.events.selectContent,
            content_type: this.events.filter,
            element: `${category} :: ${filter}`,
            layer: this.events.hotels
        }

        this.analytics.set(this.events.trackEvent, data);
    }

    onClickOpenMap(paxes) {
        const data = {
            event: this.events.gtmEvent,
            eventName: this.events.mapOpen,
            eventCategory: this.events.hotels,
            eventAction: 'list',
            eventLabel: `${this.place.displayText} | ${this.booker.checkIn} | ${this.booker.checkOut} | ${paxes.adults} | p${paxes.children}`,
            eventExtra: '',            
        }
        this.analytics.set(this.events.gtmEvent, data);
    }
    onClickMapToDetail(paxes) {
        const data = {
            event: this.events.gtmEvent,
            eventName: this.events.mapOpen,
            eventCategory: this.events.hotels,
            eventAction: 'open_map_detail',
            eventLabel: `${this.place.displayText} | ${this.booker.checkIn} | ${this.booker.checkOut} | ${paxes.adults} | p${paxes.children}`,
            eventExtra: '',     
        }
        this.analytics.set(this.events.gtmEvent, data);
    }
    clickOfferWow(paxes) {
        const data = {
            event: this.events.gtmEvent,
            eventName: this.events.offer_wow,
            eventCategory: this.events.hotels,
            eventAction: 'click_offer_wow',
            eventLabel: `${this.place.displayText} | ${this.booker.checkIn} | ${this.booker.checkOut} | ${paxes.adults} | p${paxes.children}`,
            eventExtra: '',     
        }
        this.analytics.set(this.events.gtmEvent, data);
    }
    onClickImpression(hotel) {

        if (['TB', 'US', 'PT'].includes(this.settings.site.metricsSuffix)) {
            this.viewItemListTB([hotel], this.events.selectItem);
            return;
        }

        const base = this.impressionBase(hotel);
        const data = {
            event: this.events.impressionClick,
            EECImpressionClickList: this.events.hotelList,
            EECIDestinationUrl: base.EECIImpressionBaseDestinationUrl,
            EECImpressionImageUrl: base.EECImpressionBaseImageUrl,
            EECImpressionPlaceText: base.EECImpressionBasePlaceText,
            EECImpressionProductUrl: base.EECImpressionBaseProductUrl,
            EECImpressionClickAdults: base.EECImpressionBaseAdults,
            EECImpressionClickAvailable: base.EECImpressionBaseAvailable,
            EECImpressionClickCheckin: base.EECImpressionBaseCheckin,
            EECImpressionClickCheckout: base.EECImpressionBaseCheckout,
            EECImpressionClickCity: base.EECImpressionBaseCity,
            EECImpressionClickCountry: base.EECImpressionBaseCountry,
            EECImpressionClickId: base.EECImpressionBaseId,
            EECImpressionClickKids: base.EECImpressionBaseKids,
            EECImpressionClickMealplan: base.EECImpressionBaseMealplan,
            EECImpressionClickName: base.EECImpressionBaseName,
            EECImpressionClickNights: base.EECImpressionBaseNights,
            EECImpressionClickPlaceId: base.EECImpressionBasePlaceId,
            EECImpressionClickPosition: base.EECImpressionBasePosition,
            EECImpressionClickProfileId: base.EECImpressionBaseProfileId,
            EECImpressionClickQuantity: base.EECImpressionBaseQuantity,
            EECImpressionClickRating: base.EECImpressionBaseRating,
            EECImpressionClickStars: base.EECImpressionBaseStars,
            EECImpressionClickState: base.EECImpressionBaseState,
            EECImpressionClickWeek: base.EECImpressionBaseWeek,
            EECImpressionClickWeekDay: base.EECImpressionBaseWeekDay,

        }
        this.selectItem(hotel)
        this.analytics.set(this.events.impressionView, data);

    }


    onRenderCardImageFn() {
        this.onRenderCardImage = (element) => {
            const hotels = window.__pt.hotels || [];
            const hotel = this.fn.findObject(hotels, 'hotelId', element.dataset.hotel);
            if (hotel) {
                const base = this.impressionBase(hotel);
                const impression = {
                    EECImpressionViewList: this.events.hotelList,
                    EECIDestinationUrl: base.EECIImpressionBaseDestinationUrl,
                    EECImpressionImageUrl: base.EECImpressionBaseImageUrl,
                    EECImpressionPlaceText: base.EECImpressionBasePlaceText,
                    EECImpressionProductUrl: base.EECImpressionBaseProductUrl,
                    EECImpressionViewAdults: base.EECImpressionBaseAdults,
                    EECImpressionViewAvailable: base.EECImpressionBaseAvailable,
                    EECImpressionViewCheckin: base.EECImpressionBaseCheckin,
                    EECImpressionViewCheckout: base.EECImpressionBaseCheckout,
                    EECImpressionViewCity: base.EECImpressionBaseCity,
                    EECImpressionViewCountry: base.EECImpressionBaseCountry,
                    EECImpressionViewId: base.EECImpressionBaseId,
                    EECImpressionViewKids: base.EECImpressionBaseKids,
                    EECImpressionViewMealplan: base.EECImpressionBaseMealplan,
                    EECImpressionViewName: base.EECImpressionBaseName,
                    EECImpressionViewNights: base.EECImpressionBaseNights,
                    EECImpressionViewPage: base.EECImpressionBasePage,
                    EECImpressionViewPlaceId: base.EECImpressionBasePlaceId,
                    EECImpressionViewPosition: base.EECImpressionBasePosition,
                    EECImpressionViewProfileId: base.EECImpressionBaseProfileId,
                    EECImpressionViewQuantity: base.EECImpressionBaseQuantity,
                    EECImpressionViewRating: base.EECImpressionBaseRating,
                    EECImpressionViewStars: base.EECImpressionBaseStars,
                    EECImpressionViewState: base.EECImpressionBaseState,
                    EECImpressionViewWeek: base.EECImpressionBaseWeek,
                    EECImpressionViewWeekDay: base.EECImpressionBaseWeekDay,
                    EECImpressionViewChannel: base.EEImpressionViewChannel
                };

                const data = {
                    event: this.events.impressionView,
                    EECImpressionViewImpressions: [impression]
                }

                if (hotel.taxes === undefined) {
                    this.waitingList.push([hotel, impression]);
                } else {
                    this.analytics.set(this.events.impressionView, data);
                }
            }

        }
    }
    setEventFilterHotelName(hotel, search, placeName, place) {
        const pax = this._paxes;
        const data = {
            event: this.events.gtmEvent,
            eventName: this.events.selectContent,
            eventCategory: this.events.hotels,
            eventAction: this.events.filter,
            eventLabel: `${this.events.nameHotel} :: ${search}`,
            eventExtra: `${place.id} :: ${place.name}`,
        }
        this.analytics.set(this.events.gtmEvent, data);
    }
    //Cards renderizadas antes de la cotización
    afterLoadRates() {
        // [0] = Hotel object
        // [1] = impression object
        this.waitingList.map((element) => {
            element[1].EECImpressionViewAvailable = element[0].taxes != null;
            const data = {
                event: this.events.impressionView,
                EECImpressionViewImpressions: [element[1]]
            }

            this.analytics.set(this.events.impressionView, data);
        });
        this.waitingList = [];
    }

    viewItemList(hotels) {
        if (['TB', 'US', 'PT'].includes(this.settings.site.metricsSuffix)) {
            this.viewItemListTB(hotels, this.events.viewItemList);
            return;
        }

        if (window.dataLayer && window.dataLayer.some(evt => evt.event === this.events.viewItemList)) {
            return;
        }

        const hotelLenght = hotels.length;
        let data = {
            event: this.events.viewItemList,
            ecommerce: {
                items: [],
            }
        };

        for (let i = 0; i < hotelLenght; i++) {
            const hotel = hotels[i];
            const base = this.itemBase(hotel);
            data.ecommerce.items.push({
                item_id: base.itemId,
                item_name: base.itemName,
                price: base.price,
                item_brand: base.itemBrand,
                item_category: base.itemCategory,
                item_list_name: base.itemList,
                index: base.position
            });
        }

        this.analytics.set(this.events.viewItemList, data);
    }

    viewItemListTB(hotels, evtName) {
        const hotelLenght = hotels.length;
        const data = {
            event: `ga4.${this.events.trackEvent}`,
            eventName: evtName,
            eventParams: {
                currency: this.settings.site.currency,
                field_destination: this.place.id,
                field_destination_name: this.place.name,
                channel: this.settings.site.channelFac,
                field_date1: this.fn.formatDate(this.checkIn, this.settings.formatDate),
                field_date2: this.fn.formatDate(this.checkOut, this.settings.formatDate),
                field_rooms: this.booker.pax.rooms,
                field_total_nights: this.days,
                travelers_adults: this.booker.pax.adults,
                travelers_children: this.booker.pax.children.length,
                page_type: this.pages[this.settings.page],
                layer: this.events.hotels,
                timestamp: Date.now(),
                items: []
            }

        }

        for (let i = 0; i < hotelLenght; i++) {
            const hotel = hotels[i];
            const base = this.itemBase(hotel);
            data.eventParams.items.push({
                item_id: base.itemId,
                item_name: base.itemName,
                item_brand: base.itemBrand,
                item_category: 'hotel',
                item_category2: 'hotel',
                item_variant: null,
                price: base.price,
                coupon: base.coupon,
                item_list_name: base.itemList,
                item_list_id: ""
            });
        }

        this.analytics.set(this.events.viewItemList, data);
    }

    selectItem(hotel) {
        const base = this.itemBase(hotel);
        let data = {
            event: this.events.selectItem,
            ecommerce: {
                items: [{
                    item_id: base.itemId,
                    item_name: base.itemName,
                    price: base.price,
                    item_brand: base.itemBrand,
                    item_category: base.itemCategory,
                    item_list_name: base.itemList,
                    index: base.position
                }],
                currency: this.settings.site.currency,
                item_list_name: this.place.name,
                item_list_id: this.place.id
            }
        };



        this.analytics.set(this.events.selectItem, data);
    }

    itemBase(hotel) {
        return {
            itemId: hotel.hotelId,
            itemName: hotel.name,
            price: hotel.price || 0,
            itemBrand: hotel.uri,
            itemCategory: this.settings.page,
            itemList: this.place.name,
            position: hotel.position,
            coupon: hotel.taxes ? hotel.taxes.promotionId : null
        }
    }

    impressionBase(hotelItem) {
        const rate = this._rateParam;
        const pax = this._paxes;
        const hotelListParams = this._hotelParam;
        const hotel = hotelItem || {};
        const base = {
            EECIImpressionBaseDestinationUrl: this.url,
            EECImpressionBaseImageUrl: hotel.mainPhoto && hotel.mainPhoto.cloudUri,
            EECImpressionBasePlaceText: this.place.displayText,
            EECImpressionBaseProductUrl: hotel.url,
            EECImpressionBaseAdults: pax.adults,
            EECImpressionBaseAvailable: hotel.taxes != null,
            EECImpressionBaseCheckin: hotelListParams.checkIn,
            EECImpressionBaseCheckout: hotelListParams.checkOut,
            EECImpressionBaseCity: hotel.locationInfo && hotel.locationInfo.city,
            EECImpressionBaseCountry: hotel.locationInfo && hotel.locationInfo.country,
            EECImpressionBaseId: hotel.hotelId,
            EECImpressionBaseKids: pax.children,
            EECImpressionBaseMealplan: "",
            EECImpressionBaseName: hotel.name,
            EECImpressionBaseNights: this.days,
            EECImpressionBasePage: hotel.page,
            EECImpressionBasePlaceId: this.place.id,
            EECImpressionBasePosition: hotel.position,
            EECImpressionBaseProfileId: rate.profileId || "",
            EECImpressionBaseQuantity: pax.paxesFormat.length,
            EECImpressionBaseRating: ((hotel.surveyAverage && hotel.surveyAverage.averageValue) || 0) * 2,
            EECImpressionBaseStars: hotel.stars,
            EECImpressionBaseState: hotel.locationInfo && hotel.locationInfo.state,
            EECImpressionBaseWeek: this.date.getDate(),
            EECImpressionBaseWeekDay: this.date.getDay(),
            EEImpressionViewChannel: this.settings.site.channelFac
        }

        return base;
    }

    orderEvent(order) {

        const options = {
            "order-price|desc" : "mayor_menor",
            "order-price|asc" : "menor_mayor",
            "recommended|desc" : "recomendacion"
        };

        let data = {
            event: this.events.trackEvent,
            eventName:"select_content",
            content_type: this.events.button,
            element: `ordertype :: ${options[order]}`,
            layer: this.events.hotels,
            page_type: this.pages[this.settings.page]
        }

        this.analytics.set(this.events.trackEvent, data);
    }


    errorQuote(error, step) {
        let guid = error ? error.guid || "" : "NA";
        const payload = JSON.stringify(error || {});
        const hotelListParams = this._hotelParam;
        const pax = this._paxes;

        const data = {
            event: this.events.errorQuote,
            eq_destination: this.place.displayText,
            eq_arrival: hotelListParams.checkIn,
            eq_departure: hotelListParams.checkOut,
            eq_adults: pax.adults,
            eq_children: pax.children,
            eq_detail: payload,
            eq_step: step,
            eq_guid: guid,
            eq_path: this.url,
            eq_url: this.url_full
        }

        this.analytics.set(this.events.errorQuote, data);
    }

    selectDateSuggested(itemSelected) {
        const pax = this._paxes;
        
        const data = {
            event: `ga4.${this.events.trackEvent}`,
            eventName: this.events.selectContent,
            eventParams: {
                element: `available_dates:: <<${itemSelected.CheckIn}|${itemSelected.CheckOut}>`,
                field_date1: itemSelected.CheckIn,
                field_date2: itemSelected.CheckOut,
                field_hotel_name: itemSelected.hotelName,
                travelers_adults: pax.adults,
                travelers_children: pax.paxes.children,
                field_hotel_id: itemSelected.hotelId,
                field_rooms:  this.booker.pax.rooms,
                page_type: this.pages[this.settings.page],
                layer: this.events.hotels,
                content_type: this.events.button
            }
        }

        this.analytics.set(this.events.gtmEvent, data);
    }


}
